import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { TurnaroundFrame } from "../../TurnaroundFrame/index.js";
import { cn as clsx } from "../../../helpers/react.js";
import { useIndexTableDisabled } from "../IndexTableContext.js";
import '../../../assets/index23.css';const progressCell = "_progressCell_1di33_2";
const vertical = "_vertical_1di33_23";
const red = "_red_1di33_27";
const disabled = "_disabled_1di33_31";
const percents = "_percents_1di33_37";
const progressBackground = "_progressBackground_1di33_41";
const progressForeground = "_progressForeground_1di33_51";
const time = "_time_1di33_61";
const compactBackground = "_compactBackground_1di33_66";
const extraLayer = "_extraLayer_1di33_74";
const compactForeground = "_compactForeground_1di33_83";
const s = {
  progressCell,
  vertical,
  red,
  disabled,
  percents,
  progressBackground,
  progressForeground,
  time,
  compactBackground,
  extraLayer,
  compactForeground
};
const IndexTableCellProgress = forwardRef(
  ({ className, progressPercents, remainingMs, red: red2, variant = "vertical", ...rest }, ref) => {
    const disabled2 = useIndexTableDisabled(rest);
    const width = `${Number.isFinite(progressPercents) ? progressPercents : 0}%`;
    return /* @__PURE__ */ jsxs(
      "div",
      {
        ...rest,
        ref,
        className: clsx(
          s.progressCell,
          {
            [s.disabled]: disabled2,
            [s.red]: !disabled2 && red2,
            [s.vertical]: variant === "vertical"
          },
          className
        ),
        children: [
          /* @__PURE__ */ jsx("span", { className: s.percents, children: width }),
          variant !== "horizontal-compact" ? /* @__PURE__ */ jsx("div", { className: s.progressBackground, children: /* @__PURE__ */ jsx(
            "span",
            {
              className: s.progressForeground,
              style: {
                width
              }
            }
          ) }) : /* @__PURE__ */ jsx("div", { className: s.compactBackground, children: /* @__PURE__ */ jsx("div", { className: s.extraLayer, children: /* @__PURE__ */ jsx(
            "span",
            {
              className: s.compactForeground,
              style: {
                width
              }
            }
          ) }) }),
          remainingMs && /* @__PURE__ */ jsx("span", { className: s.time, children: TurnaroundFrame.formatTime(remainingMs) })
        ]
      }
    );
  }
);
export {
  IndexTableCellProgress
};
